import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { MaterialModule } from '@app/material/material.module';
import { SharedModule } from '@shared/shared.module';
import { SecurityAccessGuardService } from '@app/shared/guards/security-access.guard';
import { AnswerSetAddQuestionDialogModule } from './dialogs/answer-set-add-question-dialog/answer-set-add-question-dialog.module';
import { GenerateDocumentsDialogModule } from './dialogs/generate-documents-dialog/generate-documents-dialog.module';
import { GeneratePDFDialogModule } from './dialogs/generate-pdf-dialog/generate-pdf-dialog.module';
import { AnswerSetComponent } from './answer-set.component';
import {
  CustomFieldRadioComponent
} from '@shared/components/formly-custom-templates/custom-field-radio/custom-field-radio.component';
import { CustomFieldInputComponent
} from '@shared/components/formly-custom-templates/custom-field-input/custom-field-input.component';
import { CheckboxWrapperComponent
} from '@shared/components/formly-custom-templates/custom-field-checkbox/checkbox-wrapper.component';
import {
  CustomFieldDatePickerComponent
} from '@shared/components/formly-custom-templates/custom-field-date-picker/custom-field-date-picker.component';
import {
  CustomFieldCheckboxComponent
} from '@shared/components/formly-custom-templates/custom-field-checkbox/custom-field-checkbox.component';
import {
  RadioWrapperComponent
} from '@app/shared/components/formly-custom-templates/custom-field-radio/radio-wrapper.component';
import { AnswerSetHeaderDetailsComponent } from './components/answer-set-header-details/answer-set-header-details.component';

const appRoutes: Routes = [
  {
    path: 'answer-set/:id',
    component: AnswerSetComponent,
    canActivate: [SecurityAccessGuardService]
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyBootstrapModule,
    MaterialModule,
    SharedModule,
    AnswerSetAddQuestionDialogModule,
    GenerateDocumentsDialogModule,
    GeneratePDFDialogModule,
    FormlyModule.forRoot({
      types: [
        { name: 'custominput', component: CustomFieldInputComponent },
        { name: 'date', component: CustomFieldDatePickerComponent },
        { name: 'customcheckbox', component: CustomFieldCheckboxComponent },
        { name: 'customradio', component: CustomFieldRadioComponent },
      ],
      wrappers: [
        { name: 'customcheckboxwrapper', component: CheckboxWrapperComponent },
        { name: 'customradiowrapper', component: RadioWrapperComponent }
      ]
    }),
    RouterModule.forChild(appRoutes)
  ],
  declarations: [
    AnswerSetComponent,
    AnswerSetHeaderDetailsComponent
  ],
  entryComponents: [AnswerSetHeaderDetailsComponent]
})
export class AnswerSetModule { }
